/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Section_PortalsInputs */

const cs_integrations_section_portals = /** @type {(inputs: Integrations_Section_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portály`)
};

const en_integrations_section_portals = /** @type {(inputs: Integrations_Section_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portals`)
};

/**
* | output |
* | --- |
* | "Portals" |
*
* @param {Integrations_Section_PortalsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_section_portals = /** @type {((inputs?: Integrations_Section_PortalsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Section_PortalsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_section_portals(inputs)
	return cs_integrations_section_portals(inputs)
});